import React, { Component } from 'react'
import { Layout, PageTitle, Container } from 'src/components/Layout'
import PropTypes from 'prop-types'

import List from 'src/components/List'

import EventsService from 'src/utils/events-service'
import { injectIntl, FormattedMessage } from 'react-intl'
import { getCurrentPageUrlInfo, capitalize, hasFeatureFlag } from 'src/utils/helpers'
import { Box } from '@chakra-ui/react'

import ChangeLanguage from 'src/modals/ChangeLanguage/index'

import './Profile.module.less'
import intlMessagesContact from '../../Contact/translations'
import intlMessagesProfile from '../translations'

class Profile extends Component {
  state = {
    showChangeLanguageModal: false,
  }
  static contextTypes = {
    router: PropTypes.object,
  }

  getNameInitals = name => {
    return name
      .match(/(\b\S)?/g)
      .join('')
      .match(/(^\S|\S$)?/g)
      .join('')
      .toUpperCase()
  }

  logout = async () => {
    const { userLastAccessType, resetUser, resetApp, isWidget, history } = this.props

    const logOutEventType =
      userLastAccessType === 'logInAsKioskUserLink' ? 'logOutAsKioskUser' : 'logOut'

    await EventsService.registerEvent({ isWidget: isWidget }, 'access', logOutEventType)

    resetUser()
    resetApp('logOut', isWidget, history)
  }

  loadData = () => {
    const { getOtherUsers } = this.props
    if (typeof getOtherUsers === 'function') {
      getOtherUsers()
    }
  }

  componentDidMount() {
    const { setAppActionsDisabledState } = this.props
    setAppActionsDisabledState(false)
    this.loadData()
  }

  getUsersCount() {
    const { otherUsers } = this.props
    if (otherUsers && otherUsers.length) {
      return otherUsers.length === 1 ? otherUsers.length + ' user' : otherUsers.length + ' users'
    }
    return ''
  }

  getContactTitle() {
    const { intl, countryIsoCode } = this.props

    const title =
      countryIsoCode && countryIsoCode.toLowerCase() === 'us'
        ? intl.formatMessage(intlMessagesContact.contactHeaderMyAgent)
        : intl.formatMessage(intlMessagesContact.contactHeaderMyBroker)
    return capitalize(title)
  }

  render() {
    const {
      intl,
      user,
      featureFlags,
      history,
      location,
      areAppActionsDisabled,
      language,
      isWidget,
    } = this.props
    let $this = this

    const items = [
      {
        // nameInitials: user.avatar ? '' : this.getNameInitals(user.name),
        image: user.avatar,
        name: intl.formatMessage(intlMessagesProfile.profileYourProfile),
        description: user.email,
        radius: '50%',
        id: intl.formatMessage(intlMessagesProfile.profileYourProfile),
        onClick: () => {
          history.push('/user/profile')
        },
      },
      {
        leftIcon: ['far', 'users'],
        name: intl.formatMessage(intlMessagesProfile.usersHeadline),
        description: this.getUsersCount(),
        id: intl.formatMessage(intlMessagesProfile.usersHeadline),
        onClick: () => {
          history.push('/users')
        },
        disable: user && user.hasOwnProperty('vuaId') && user.vuaId,
      },
      {
        leftIcon: ['far', 'user-tie'],
        name: this.getContactTitle(),
        id: 'contact',
        onClick: () => {
          history.push('/contact')
        },
        disable: !hasFeatureFlag(featureFlags, 'pages.contact'),
      },
      {
        leftIcon: ['far', 'globe'],
        name: <FormattedMessage id='app.header.links.languageTitle' defaultMessage='Language' />,
        id: 'language',
        description: language === 'en' ? 'English' : 'Français',
        onClick: () => {
          this.setState({ showChangeLanguageModal: true })
        },
      },
      {
        leftIcon: ['far', 'bell'],
        name: intl.formatMessage(intlMessagesProfile.profileNotifications),
        onClick: () => {
          history.push('/user/notifications')
        },
        id: intl.formatMessage(intlMessagesProfile.profileNotifications),
        hidden: isWidget,
      },
      {
        leftIcon: ['far', 'right-from-bracket'],
        name: <FormattedMessage id='app.header.links.logout' defaultMessage='Logout' />,
        hideArrowAlways: true,
        onClick: () => {
          $this.logout()
        },
      },
    ]

    const currentPageUrl = getCurrentPageUrlInfo(location, 'url')

    const isChatPage = currentPageUrl === '/chat'

    return (
      <Layout>
        <PageTitle title={<FormattedMessage id='app.profileTab' defaultMessage='Profile' />} />
        <Container>
          <Box
            px={{ base: '20px', lg: 0 }}
            pt={{ md: '20px', lg: '20px' }}
            pb={{ md: '20px', lg: '40px' }}
          >
            <List
              items={items}
              isProfile={true}
              noMargin={true}
              preventActiveState={isChatPage}
              areAppActionsDisabled={areAppActionsDisabled}
            />
          </Box>
          <ChangeLanguage
            visible={this.state.showChangeLanguageModal}
            onClose={() => this.setState({ showChangeLanguageModal: false })}
          />
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(Profile)
